module.exports.parseJsonSafely = function(jsonStr) {
    try {
        return JSON.parse(jsonStr);
    }
    catch {
        return null;
    }   
}